module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABsSURBVHgBjY0BDYAgEEV/BCIQgQZG0SYSwQZGIIIRjGAEIpx37thu7ET/9hhw/wEAXErAONF0n4WYcyAGnVOTohHLi1SMEPuvZbB3wuYJLYmpWsh6l/VcPcGKpBxmn/CRxZSFGT8jL6/M5A1vb/0incobOZIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/common/deposit-list-icon-less.png
// module id = Og3d
// module chunks = 0